module.exports = __webpack_public_path__ + "img/tokyu-vacation-reservation.65108a1e.jpg";